import { render } from "./CalculatorsPage.vue?vue&type=template&id=09aab091&scoped=true"
import script from "./CalculatorsPage.vue?vue&type=script&lang=js"
export * from "./CalculatorsPage.vue?vue&type=script&lang=js"

import "./CalculatorsPage.vue?vue&type=style&index=0&id=09aab091&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09aab091"]])

export default __exports__